import { gql } from '@parkchirp/api-client';

export const LIST_ORGANIZATION_PARKER_TYPES = gql`
	query listOrganizationParkerTypes(
		$organizationId: Int!
		$order: SortOrder
		$filters: [Filter]
		$limit: Int!
		$offset: Int!
		$report: String
	) {
		listOrganizationParkerTypes(
			organizationId: $organizationId
			order: $order
			filters: $filters
			limit: $limit
			offset: $offset
			report: $report
		) {
			organizationParkerTypes {
				id
				parkerTypeName
				isDefault
				createdAt
			}
			defaultOrganizationParkerTypeId
			count
		}
	}
`;

export const GET_ORGANIZATION_PARKER_TYPES_CSV = gql`
	query getOrganizationParkerTypesCSV(
		$organizationId: Int!
		$order: SortOrder
		$filters: [Filter]
	) {
		getOrganizationParkerTypesCSV(
			organizationId: $organizationId
			order: $order
			filters: $filters
		) {
			url
		}
	}
`;
